<template>
  <div>
    <page-header :title="$t('bastionHost.title')" />
    <page-body>
      <list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'BastionHostIndex',
  components: {
    List,
  },
  data () {
    return {
      listId: 'BastionHostList',
    }
  },
}
</script>
